<template>
  <div class="card">
    <h2>پیام‌ها</h2>
    <p>در این قسمت پیام‌های شما نمایش داده می‌شود.</p>
  </div>
</template>

<script>
export default { name: 'MessagesView' }
</script>

<style scoped>
.card { background: var(--card); border:1px solid var(--border); border-radius:16px; padding:24px; box-shadow: 0 8px 24px rgba(0,0,0,0.06); }
</style>
